// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createAction } from 'redux-actions'
import { CallType } from '@weblite/ts-action/media-proxy'
import { CallMessageStatus } from '@weblite/ts-action/message'
import { dispatch, getState } from '$setup/redux'
import { CallState } from './types'

export interface CallStorage {
  state: CallState
  roomId: string
  callType?: CallType
  muted: boolean
  hasNextCall?: boolean
  startedAt?: number
  joinedAt?: number

  // PV
  status?: CallMessageStatus
  isCaller?: boolean
  duration?: number

  // MEET / LIVE / TRIBUNE
  name: string
  isOwner?: boolean
  isParticipating?: boolean
}

const initialState: CallStorage = {
  state: 'none',
  roomId: '',
  callType: undefined,
  muted: true,
  hasNextCall: false,
  startedAt: undefined,
  joinedAt: undefined,

  // PV
  status: undefined,
  isCaller: true,

  // MEET / LIVE / TRIBUNE
  name: '',
  isOwner: false,
  isParticipating: false,
}

// actions
const RESET_CALL = 'RESET_CALL'
const resetCall = createAction(RESET_CALL)

const UPDATE_CALL = 'UPDATE_CALL'
const updateCall = createAction(UPDATE_CALL)

export const callStorage = {
  get: () => getState().main.call as CallStorage,
  set: (call: Partial<CallStorage>) => dispatch(updateCall(call)),
  reset: () => dispatch(resetCall()),
}

// reducers
const reducers = {
  [RESET_CALL]: () => initialState,

  [UPDATE_CALL]: (state: CallStorage, update: Partial<CallStorage>) => ({
    ...state,
    ...update,
  }),
}

export const callReducer = (
  state = initialState,
  { type, payload }: { type: keyof typeof reducers; payload: any },
) => (reducers[type] ? reducers[type](state, payload) : state)
